{
  "dashboard": {
    "logoAlt": "Smart Word Labs",
    "nav": {
      "adminPortal": "Portail administrateur",
      "enquiries": "Demandes",
      "signOut": "Se déconnecter"
    },
    "hero": {
      "adminBadge": "Compte administrateur",
      "parentBadge": "Compte parent",
      "greeting": "Bonjour {{name}}",
      "subtitle": "Leçons, facturation, progrès et messages du tuteur pour chaque enfant de votre famille.",
      "addChild": "Ajouter un enfant",
      "form": {
        "childName": "Nom de l'enfant",
        "age": "Âge",
        "save": "Enregistrer"
      }
    },
    "plan": {
      "title": "Choisissez un forfait mensuel",
      "description": "Votre évaluation gratuite est toujours incluse. Un forfait mensuel débloque les leçons en cohorte en direct, les commentaires sur les devoirs et les rapports de progression CECRL.",
      "viewPlans": "Voir les forfaits"
    },
    "studentMode": {
      "title": "Mode Étudiant",
      "nextLesson": "Prochaine leçon {{datetime}} — un clic, pas de connexion séparée pour votre enfant.",
      "noLesson": "Aucune leçon en direct programmée pour le moment. Votre prochaine session de cohorte apparaîtra ici.",
      "joinClass": "Rejoindre le cours"
    },
    "scheduling": {
      "title": "Leçons et programmation",
      "bookAnother": "Réserver une autre évaluation",
      "lessonFallback": "Leçon",
      "reschedule": "Reprogrammer",
      "rescheduleToast": {
        "title": "Reprogrammation demandée",
        "description": "Votre tuteur confirmera un nouveau créneau par e-mail."
      },
      "empty": {
        "title": "Réservez votre évaluation gratuite",
        "description": "Un appel de diagnostic de 20 minutes avec Mme Salma permet de définir le niveau CECRL de votre enfant et son plan d'apprentissage. C'est gratuit et inclus avec chaque compte.",
        "cta": "Réserver une évaluation gratuite"
      }
    },
    "billing": {
      "title": "Facturation et abonnement",
      "pastDue": "Votre dernier paiement a échoué. Mettez à jour votre carte pour continuer les leçons.",
      "plan": "Forfait",
      "noPlan": "Aucun forfait actif",
      "status": "Statut",
      "statusNone": "aucun",
      "accessEnds": "L'accès prend fin le",
      "renewsOn": "Se renouvelle le",
      "childrenEnrolled": "Enfants inscrits",
      "manageSubscription": "Gérer l'abonnement",
      "opening": "Ouverture…",
      "choosePlan": "Choisir un forfait"
    },
    "progress": {
      "title": "Rapports de progression",
      "cefrLevel": "Niveau CECRL",
      "awaitingAssessment": "En attente d'évaluation",
      "lessonsCompleted": "Leçons terminées",
      "homeworkReviewed": "Devoirs corrigés",
      "submitHomework": "Soumettre un devoir"
    },
    "homeworkFeedback": {
      "title": "Devoirs et commentaires du tuteur",
      "empty": "Aucun devoir soumis pour le moment."
    },
    "messages": {
      "title": "Messages de votre tuteur",
      "empty": "Aucun message pour le moment. Votre tuteur publiera les notes de leçon ici après chaque session."
    },
    "toasts": {
      "childAdded": "Profil de l'enfant ajouté",
      "paymentReceived": {
        "title": "Paiement reçu",
        "description": "Configuration de votre forfait — cela prend quelques secondes."
      },
      "portalUnavailable": "Portail indisponible",
      "portalError": "Impossible d'ouvrir le portail de facturation"
    }
  },
  "homework": {
    "backToDashboard": "Retour au tableau de bord",
    "title": "Soumettre un devoir",
    "description": "Téléchargez un enregistrement de lecture et toutes les pages de fiches d'exercices. Les fichiers sont stockés de manière privée et ne sont visibles que par votre tuteur.",
    "form": {
      "lesson": "Leçon",
      "selectLesson": "Sélectionner une leçon",
      "lessonFallback": "Leçon",
      "noBookings": "Vous devez avoir une leçon réservée avant de soumettre un devoir.",
      "audioRecording": "Enregistrement audio",
      "worksheet": "Fiche d'exercice (PDF ou image)",
      "uploading": "Téléchargement…",
      "submit": "Soumettre le devoir"
    },
    "submissions": {
      "title": "Vos soumissions",
      "audio": "Audio",
      "worksheet": "Fiche d'exercice",
      "watchVideoFeedback": "Regarder le commentaire vidéo du tuteur",
      "empty": "Rien n'a été soumis pour le moment."
    },
    "errors": {
      "fileTooLarge": "Le fichier {{kind}} doit faire moins de 25 Mo",
      "chooseLesson": "Choisissez la leçon à laquelle ce devoir appartient",
      "attachFile": "Joignez un enregistrement audio ou une fiche d'exercice",
      "uploadFailed": "Le téléchargement a échoué",
      "openFileFailed": "Impossible d'ouvrir le fichier"
    },
    "toasts": {
      "submitted": "Devoir soumis — votre tuteur a été informé"
    }
  },
  "messagesPage": {
    "backToPortal": "Retour au portail",
    "title": "Demandes du site web",
    "description": "Messages envoyés via le formulaire de contact. Vous seul pouvez les voir.",
    "exportCsv": "Exporter en CSV",
    "loading": "Chargement des demandes…",
    "empty": "Aucune demande pour le moment.",
    "childAge": "âge de l'enfant {{age}}",
    "status": {
      "handled": "Traité",
      "new": "Nouveau"
    },
    "actions": {
      "reopen": "Rouvrir",
      "markHandled": "Marquer comme traité"
    },
    "csv": {
      "headers": {
        "received": "Reçu",
        "name": "Nom",
        "email": "E-mail",
        "whatsapp": "WhatsApp",
        "childAge": "Âge de l'enfant",
        "subject": "Objet",
        "message": "Message",
        "status": "Statut"
      },
      "filename": "smart-word-labs-demandes-{{date}}"
    },
    "toasts": {
      "updateFailed": "Impossible de mettre à jour cette demande.",
      "nothingToExport": "Il n'y a aucune demande à exporter pour le moment.",
      "exported_one": "{{count}} demande exportée.",
      "exported_other": "{{count}} demandes exportées."
    }
  },
  "admin": {
    "backToDashboard": "Retour au tableau de bord",
    "title": "Portail administrateur",
    "description": "Paiements, réservations, versements et comptes utilisateurs pour Smart Word Labs.",
    "tabs": {
      "payments": "Paiements",
      "bookings": "Réservations",
      "payouts": "Versements",
      "users": "Utilisateurs"
    },
    "table": {
      "loading": "Chargement…",
      "clearFilters": "Effacer les filtres",
      "details": "Détails",
      "view": "Voir",
      "action": "Action"
    },
    "payments": {
      "searchPlaceholder": "Rechercher un étudiant ou un tuteur",
      "searchAriaLabel": "Rechercher des paiements par nom d'étudiant ou de tuteur",
      "filterAriaLabel": "Filtrer par statut de paiement",
      "filterPlaceholder": "Statut du paiement",
      "statuses": {
        "all": "Tous les statuts de paiement",
        "unpaid": "Impayé",
        "paid": "Payé",
        "refunded": "Remboursé"
      },
      "columns": {
        "student": "Étudiant",
        "tutor": "Tuteur",
        "programme": "Programme",
        "amount": "Montant",
        "payment": "Paiement",
        "created": "Créé le"
      },
      "empty": "Aucun paiement ne correspond à ces filtres pour le moment.",
      "refund": "Rembourser",
      "confirm": {
        "title": "Rembourser ce paiement ?",
        "description": "Ceci émet un remboursement réel via Stripe pour <strong>{{name}}</strong> ({{amount}}) et marque la réservation comme remboursée. Cette action est irréversible.",
        "fallbackName": "cet étudiant",
        "cancel": "Annuler",
        "confirm": "Rembourser le paiement"
      },
      "toasts": {
        "success": "Remboursement effectué et la réservation est désormais marquée comme remboursée.",
        "error": "Le remboursement n'a pas pu être effectué."
      }
    },
    "bookings": {
      "status": "Statut",
      "from": "Du",
      "to": "Au",
      "statuses": {
        "all": "Tous les statuts",
        "pending": "En attente",
        "confirmed": "Confirmé",
        "completed": "Terminé",
        "canceled": "Annulé"
      },
      "columns": {
        "scheduled": "Programmé",
        "student": "Étudiant",
        "tutor": "Tuteur",
        "programme": "Programme",
        "status": "Statut",
        "payment": "Paiement"
      },
      "empty": "Aucune réservation ne correspond à ces filtres pour le moment.",
      "detail": {
        "title": "Détails de la réservation",
        "description": "Enregistrement complet pour cette réservation de leçon.",
        "student": "Étudiant",
        "studentEmail": "E-mail de l'étudiant",
        "tutor": "Tuteur",
        "programme": "Programme",
        "amount": "Montant",
        "scheduled": "Programmé",
        "created": "Créé le",
        "status": "Statut",
        "payment": "Paiement",
        "refundedAt": "Remboursé le",
        "meetingLink": "Lien de la réunion",
        "stripePayment": "Paiement Stripe"
      }
    },
    "payouts": {
      "totalPending": "Total des versements en attente",
      "filterAriaLabel": "Filtrer les versements par statut",
      "filterPlaceholder": "Statut",
      "statuses": {
        "all": "Tous les statuts",
        "pending": "En attente",
        "paid": "Payé"
      },
      "columns": {
        "tutor": "Tuteur",
        "amount": "Montant",
        "payoutDate": "Date de versement",
        "status": "Statut"
      },
      "empty": "Aucun versement enregistré pour le moment.",
      "markAsPaid": "Marquer comme payé",
      "toasts": {
        "success": "Versement marqué comme payé.",
        "error": "Impossible de mettre à jour ce versement."
      }
    },
    "users": {
      "filterAriaLabel": "Filtrer les utilisateurs par rôle",
      "filterPlaceholder": "Rôle",
      "roles": {
        "all": "Tous les rôles",
        "parent": "Parent",
        "tutor": "Tuteur",
        "admin": "Admin"
      },
      "columns": {
        "name": "Nom",
        "email": "E-mail",
        "role": "Rôle",
        "joined": "Rejoint le"
      },
      "empty": "Aucun utilisateur ne correspond à ce filtre.",
      "viewTutor": "Voir le tuteur",
      "tutorFallback": "Tutor",
      "loadingTutor": "Chargement des détails du tuteur…",
      "noTutorProfile": "Aucun profil de tuteur enregistré.",
      "detail": {
        "hourlyRate": "Taux horaire",
        "commission": "Commission",
        "active": "Actif",
        "onboardingSubmitted": "Onboarding soumis",
        "specialisation": "Spécialisation",
        "bio": "Bio",
        "yes": "Oui",
        "no": "Non"
      }
    }
  }
}
